import { createContext, useContext } from 'react';

export const WidgetPortalContext = createContext<HTMLElement | null>(null);

/** Portal target for MUI overlays when running inside widgets.investor.bundle.js. */
export function useWidgetPortalContainer(): HTMLElement | null {
  return useContext(WidgetPortalContext);
}
